/* Language selector used as a menu in the landing page */
import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { useLanguage } from '../context/LanguageContext';

const LanguageSelector = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { language, changeLanguage } = useLanguage();
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const selectLanguage = (lang) => {
    changeLanguage(lang);
    window.location.reload();
    handleClose();
  };
  
  // Map language codes to readable names
  const languageNames = {
    en: 'English',
    fr: 'Français',
    es: 'Español'
  };
  
  return (
    <>
      <Button 
        onClick={handleClick}
        color="inherit"
        sx={{ textTransform: 'none' }}
      >
        {languageNames[language]}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => selectLanguage('en')}>English</MenuItem>
        <MenuItem onClick={() => selectLanguage('fr')}>Français</MenuItem>
        <MenuItem onClick={() => selectLanguage('es')}>Español</MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSelector; 